<template>
  <button v-bind="$attrs" v-on="$listeners" :id="id" class="flex text-sm cursor-pointer font-medium outline-none focus:outline-none py-2 px-4 pr-3" 
    :class="[classValue, {
        'flex-row' : iconPosition === 'right', 'flex-row-reverse' : iconPosition === 'left',
        'bg-primary text-white border border-primary hover:bg-primary-hover focus:border-primary active:bg-primary-hover' : buttonType === 'filled' && background === 'primary',
        'bg-white text-primary border border-primary hover:bg-primary-hover-2 focus:border-primary ' : buttonType === 'ghost' && background === 'primary',
        'bg-secondary text-white border border-secondary hover:bg-secondary-hover focus:border-secondary ' : buttonType === 'filled' && background === 'secondary',
        'bg-white text-secondary border border-secondary hover:bg-secondary-hover-2 focus:border-secondary' : buttonType === 'ghost' && background === 'secondary',
        'bg-complementer text-complementer-2 border border-complementer hover:bg-complementer-hover hover:text-white focus:border-complementer' : buttonType === 'filled' && background === 'complementer',
        'bg-white text-complementer-3 border border-complementer-3 hover:bg-complementer-hover-2 hover:text-secondary focus:border-complementer' : buttonType === 'ghost' && background === 'complementer',
    }]"
    >
    <slot class="select-none self-center"></slot>
    <div v-if="icon === 'arrow-right'" class="select-none self-center">
        <svg class="self-center" :class="{
            'ml-2' : iconPosition === 'right', 'mr-2' : iconPosition === 'left' }" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.92 6.61994C11.8724 6.49719 11.801 6.38505 11.71 6.28994L6.71 1.28994C6.61676 1.1967 6.50607 1.12274 6.38425 1.07228C6.26243 1.02182 6.13186 0.99585 6 0.99585C5.7337 0.99585 5.4783 1.10164 5.29 1.28994C5.19676 1.38318 5.1228 1.49387 5.07234 1.61569C5.02188 1.73751 4.99591 1.86808 4.99591 1.99994C4.99591 2.26624 5.1017 2.52164 5.29 2.70994L8.59 5.99994H1C0.734784 5.99994 0.48043 6.1053 0.292893 6.29283C0.105357 6.48037 0 6.73472 0 6.99994C0 7.26516 0.105357 7.51951 0.292893 7.70705C0.48043 7.89458 0.734784 7.99994 1 7.99994H8.59L5.29 11.2899C5.19627 11.3829 5.12188 11.4935 5.07111 11.6154C5.02034 11.7372 4.9942 11.8679 4.9942 11.9999C4.9942 12.132 5.02034 12.2627 5.07111 12.3845C5.12188 12.5064 5.19627 12.617 5.29 12.7099C5.38296 12.8037 5.49356 12.8781 5.61542 12.9288C5.73728 12.9796 5.86799 13.0057 6 13.0057C6.13201 13.0057 6.26272 12.9796 6.38458 12.9288C6.50644 12.8781 6.61704 12.8037 6.71 12.7099L11.71 7.70994C11.801 7.61484 11.8724 7.50269 11.92 7.37994C12.02 7.13648 12.02 6.8634 11.92 6.61994Z" 
            :fill="buttonType === 'filled' ? '#ffffff' : '#E81255'"
        />
        </svg>
    </div>
    <div v-if="icon === 'send-message'" class="select-none self-center">
        <svg :class="{
            'ml-2' : iconPosition === 'right', 'mr-2' : iconPosition === 'left' }" width="15" height="14" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.34 7.32001L4.34 0.320006C3.78749 0.0450154 3.16362 -0.0528833 2.55344 0.0396579C1.94326 0.132199 1.37646 0.410676 0.930335 0.837122C0.484207 1.26357 0.180456 1.81723 0.060496 2.42262C-0.059464 3.02801 0.0102046 3.65566 0.260003 4.22001L2.66 9.59001C2.71446 9.71984 2.74251 9.85922 2.74251 10C2.74251 10.1408 2.71446 10.2802 2.66 10.41L0.260003 15.78C0.0567034 16.2367 -0.029241 16.737 0.00998036 17.2354C0.0492018 17.7337 0.212345 18.2144 0.484585 18.6337C0.756825 19.053 1.12953 19.3976 1.56883 19.6362C2.00812 19.8748 2.50009 19.9999 3 20C3.46823 19.9953 3.92949 19.886 4.35 19.68L18.35 12.68C18.8466 12.4302 19.264 12.0473 19.5557 11.5741C19.8474 11.1009 20.0018 10.5559 20.0018 10C20.0018 9.44411 19.8474 8.89915 19.5557 8.42593C19.264 7.9527 18.8466 7.56982 18.35 7.32001H18.34ZM17.45 10.89L3.45 17.89C3.26617 17.9783 3.05973 18.0082 2.85839 17.9759C2.65705 17.9435 2.47041 17.8503 2.32352 17.7089C2.17662 17.5674 2.07648 17.3844 2.03653 17.1844C1.99658 16.9845 2.01873 16.777 2.1 16.59L4.49 11.22C4.52094 11.1483 4.54766 11.0748 4.57 11H11.46C11.7252 11 11.9796 10.8946 12.1671 10.7071C12.3546 10.5196 12.46 10.2652 12.46 10C12.46 9.73479 12.3546 9.48044 12.1671 9.2929C11.9796 9.10536 11.7252 9.00001 11.46 9.00001H4.57C4.54766 8.92517 4.52094 8.85172 4.49 8.78001L2.1 3.41001C2.01873 3.22297 1.99658 3.01556 2.03653 2.81558C2.07648 2.6156 2.17662 2.43261 2.32352 2.29115C2.47041 2.1497 2.65705 2.05654 2.85839 2.02416C3.05973 1.99178 3.26617 2.02174 3.45 2.11001L17.45 9.11001C17.6138 9.19392 17.7513 9.32142 17.8473 9.47845C17.9433 9.63548 17.994 9.81596 17.994 10C17.994 10.1841 17.9433 10.3645 17.8473 10.5216C17.7513 10.6786 17.6138 10.8061 17.45 10.89Z" 
            fill="white"
        />
        </svg>
    </div>
  </button>
</template>

<script>
export default {
  name: 'OcaButton',
          props: {
            id: {
                type: String,
                default: 'button'
            },
            background: {
                type: String,
                default: 'primary'
            },
            buttonType: {
                type: String,
                default: 'filled'
            },
            outline: {
                type: String,
                default: 'primary'
            },
            icon: {
                type: String,
                default: ''
            },
            iconPosition: {
                type: String,
                default: 'right'
            },
            classValue: {
                type: String,
                default: '',
            },
            isLoading: {
                type: Boolean,
                default: false
            },
        },
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

    #app {
        font-family: Inter;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .bg-loading {
        background-color: rgba(0, 0, 0, 0.5);
    }
</style>